
















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_unitPaycheckSetting_currentUnit } from '@/queries/__generated__/unitPaycheckSetting';

@Component
export default class EmployeeInfo extends Vue {
  @Prop({ type: Object, required: true }) private company!: GQL_unitPaycheckSetting_currentUnit;
}
